// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatCoverageReport" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { CoverageGapCountGenShape } from "./coverage-gap-count.gen";
import { ZeroMatchSampleGenShape } from "./zero-match-sample.gen";

export const ChatCoverageReportGenShape = z.strictObject({
  libraryId: z.string(),
  from: z.string(),
  to: z.string(),
  totalTurns: z.number(),
  zeroMatchTurns: z.number(),
  coverageGaps: z.array(CoverageGapCountGenShape),
  zeroMatchSamples: z.array(ZeroMatchSampleGenShape),
});
